import React from 'react';

export function Recommended () {
    return (
        <div class = 'recommended'>
        <h3>Recommended for today</h3>
        <div class = 'recbox'>
          <h2>Top 100</h2>
          <h3>Hits</h3>
        </div>
      </div>
    )
}